(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-category-directory"] && !Shopify.designMode) return;
  try {
    
  class StarCategoryDirectory extends HTMLElement {
    connectedCallback() {
      this.search = this.querySelector('[data-category-search]');
      this.cards = Array.from(this.querySelectorAll('[data-category-card]'));
      this.navLinks = Array.from(this.querySelectorAll('[data-category-nav-link]'));
      this.empty = this.querySelector('[data-category-empty]');
      this.status = this.querySelector('[data-category-status]');
      this.select = this.querySelector('[data-category-select]');
      this.matches = this.querySelector('[data-category-matches]');
      this.matchingLinks = this.querySelector('[data-category-matching-links]');
      this.matchingDepartments = this.querySelector('[data-category-matching-departments]');
      this.departmentMatches = this.querySelector('[data-category-department-matches]');
      this.leafMatches = this.querySelector('[data-category-leaf-matches]');
      this.layout = this.querySelector('.star-category-directory__layout');
      this.search?.addEventListener('input', this.handleSearch);
      this.select?.addEventListener('change', this.handleSearch);
      this.addEventListener('click', this.handleClick);
      this.handleSearch();
    }

    disconnectedCallback() {
      this.search?.removeEventListener('input', this.handleSearch);
      this.select?.removeEventListener('change', this.handleSearch);
      this.removeEventListener('click', this.handleClick);
    }

    handleClick = (event) => {
      if (event.target.closest('[data-category-clear]')) {
        this.search.value = '';
        this.select.value = '';
        this.handleSearch();
        this.search.focus();
      }
      const link = event.target.closest('[data-category-nav-link]');
      if (link) {
        const card = this.cards.find((item) => item.id === link.dataset.categoryTarget);
        if (card) card.open = true;
      }
    };

    handleSearch = () => {
      const query = this.search.value.trim().toLocaleLowerCase();
      const selected = this.select?.value || '';
      let visibleCount = 0;
      let categoryCount = 0;
      let departmentCount = 0;
      this.matchingLinks.replaceChildren();
      this.matchingDepartments.replaceChildren();
      this.matches.hidden = !query;
      this.layout.hidden = Boolean(query);
      this.cards.forEach((card) => {
        const inDepartment = !selected || selected === card.id;
        card.hidden = !inDepartment;
        const navLink = this.navLinks.find((link) => link.dataset.categoryTarget === card.id);
        if (navLink) navLink.hidden = !inDepartment;
        if (!inDepartment) return;
        visibleCount += 1;
        if (selected) card.open = true;
        const links = Array.from(card.querySelectorAll('.star-category-directory__links a'));
        if (!query) {
          categoryCount += links.length;
          return;
        }
        links.forEach((link) => {
          if (!link.textContent.toLocaleLowerCase().includes(query)) return;
          const result = link.cloneNode(true);
          const parent = document.createElement('small');
          parent.textContent = card.dataset.categoryTitle;
          result.append(parent);
          this.matchingLinks.append(result);
          categoryCount += 1;
        });
        if (card.dataset.categoryTitle.toLocaleLowerCase().includes(query)) {
          const destination = card.querySelector('.star-category-directory__department-cta');
          if (destination) {
            const result = destination.cloneNode(true);
            this.matchingDepartments.append(result);
            departmentCount += 1;
          }
        }
      });
      this.querySelector('[data-category-no-leaf]').hidden = categoryCount > 0 || departmentCount > 0;
      this.departmentMatches.hidden = departmentCount === 0;
      this.leafMatches.hidden = categoryCount === 0;
      if (this.empty) this.empty.hidden = visibleCount !== 0;
      if (this.status) {
        const mainCount = query ? departmentCount : visibleCount;
        const mainText = mainCount === 1 ? this.dataset.mainSingleText : this.dataset.mainPluralText;
        const subText = categoryCount === 1 ? this.dataset.subSingleText : this.dataset.subPluralText;
        this.status.textContent = `${mainText.replace('[count]', mainCount)} · ${subText.replace('[count]', categoryCount)}`;
      }
    };
  }

  if (!customElements.get('star-category-directory')) {
    customElements.define('star-category-directory', StarCategoryDirectory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-custom-sign-form"] && !Shopify.designMode) return;
  try {
    
  class StarCustomSign extends HTMLElement {
    connectedCallback() {
      this.panels = [...this.querySelectorAll('[data-step-panel]')];
      if (this.panels.length === 0) return;
      this.currentStep = this.querySelector('.star-custom-sign__errors:not([hidden])') ? 3 : 1;
      this.form = this.querySelector('form');
      this.validationError = this.querySelector('[data-custom-sign-error]');
      this.form.noValidate = true;
      this.dataset.enhanced = 'true';
      this.addEventListener('click', this.handleClick);
      this.addEventListener('submit', this.handleSubmit);
      this.addEventListener('input', this.handleInput);
      this.addEventListener('change', this.handleInput);
      this.showStep(this.currentStep, false);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('submit', this.handleSubmit);
      this.removeEventListener('input', this.handleInput);
      this.removeEventListener('change', this.handleInput);
    }

    handleClick = (event) => {
      const next = event.target.closest('[data-next-step]');
      const previous = event.target.closest('[data-previous-step]');
      if (next) {
        if (!this.validateStep(this.currentStep)) return;
        if (Number(next.dataset.nextStep) === 4) this.updateReview();
        this.showStep(Number(next.dataset.nextStep), true);
      }
      if (previous) this.showStep(Number(previous.dataset.previousStep), true);
    };

    handleInput = (event) => {
      const control = event.target;
      if (!control.willValidate || !control.validity.valid) return;
      control.removeAttribute('aria-invalid');
      if (this.validationError) {
        const describedBy = (control.getAttribute('aria-describedby') || '').split(' ').filter((id) => id && id !== this.validationError.id);
        if (describedBy.length) control.setAttribute('aria-describedby', describedBy.join(' '));
        else control.removeAttribute('aria-describedby');
        this.validationError.hidden = true;
      }
    };

    handleSubmit = (event) => {
      if (this.currentStep < 4) {
        event.preventDefault();
        if (!this.validateStep(this.currentStep)) return;
        if (this.currentStep === 3) this.updateReview();
        this.showStep(this.currentStep + 1, true);
        return;
      }
      for (let step = 1; step < 4; step += 1) {
        const panel = this.querySelector(`[data-step-panel="${step}"]`);
        if (![...panel.querySelectorAll('input, select, textarea')].some((control) => control.willValidate && !control.validity.valid)) continue;
        event.preventDefault();
        this.showStep(step, false);
        this.validateStep(step);
        return;
      }
    };

    validateStep(step) {
      const panel = this.querySelector(`[data-step-panel="${step}"]`);
      const invalid = [...panel.querySelectorAll('input, select, textarea')].find((control) => control.willValidate && !control.validity.valid);
      if (!invalid) return true;
      invalid.setAttribute('aria-invalid', 'true');
      if (this.validationError) {
        this.validationError.textContent = `${invalid.labels?.[0]?.textContent.trim() || ''}: ${invalid.validationMessage}`;
        this.validationError.hidden = false;
        const describedBy = new Set((invalid.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));
        describedBy.add(this.validationError.id);
        invalid.setAttribute('aria-describedby', [...describedBy].join(' '));
      }
      invalid.focus({ preventScroll: true });
      invalid.reportValidity();
      this.revealInvalidControl(invalid);
      requestAnimationFrame(() => {
        if (document.activeElement === invalid) this.revealInvalidControl(invalid);
      });
      return false;
    }

    revealInvalidControl(control) {
      control.scrollIntoView({ behavior: 'instant', block: 'center', inline: 'nearest' });
      const viewportTop = window.visualViewport?.offsetTop || 0;
      const viewportBottom = viewportTop + (window.visualViewport?.height || window.innerHeight);
      const header = document.getElementById('header-component')?.getBoundingClientRect();
      const safeTop = Math.max(viewportTop, header && header.bottom > viewportTop && header.top < viewportBottom ? header.bottom : viewportTop) + 16;
      const safeBottom = viewportBottom - 16;
      const bounds = control.getBoundingClientRect();
      if (safeBottom <= safeTop || bounds.top >= safeTop && bounds.bottom <= safeBottom) return;
      const offset = bounds.top + bounds.height / 2 - (safeTop + safeBottom) / 2;
      let scroller = control.parentElement;
      while (scroller && !(scroller.scrollHeight > scroller.clientHeight && /auto|scroll/.test(getComputedStyle(scroller).overflowY))) {
        scroller = scroller.parentElement;
      }
      (scroller || window).scrollBy({ top: offset, behavior: 'instant' });
    }

    updateReview() {
      const review = this.querySelector('[data-custom-sign-review]');
      const form = this.querySelector('form');
      if (!review || !form) return;

      const seenNames = new Set();
      const entries = [...form.elements].flatMap((control) => {
        if (!control.name?.startsWith('contact[') || control.type === 'hidden' || seenNames.has(control.name)) return [];
        seenNames.add(control.name);

        let value = control.value.trim();
        let label = control.labels?.[0]?.textContent || '';
        if (control.type === 'radio') {
          const selected = form.querySelector(`[name="${CSS.escape(control.name)}"]:checked`);
          value = selected?.value || '';
          label = control.closest('fieldset')?.querySelector('legend')?.textContent || label;
        } else if (control.type === 'checkbox') {
          value = control.checked ? control.value : '';
        } else if (control.tagName === 'SELECT') {
          value = control.selectedOptions[0]?.textContent || '';
        }

        label = label.replace(/\s*\*\s*$/, '').trim();
        if (!value || !label) return [];
        return [{ label, value }];
      });

      review.replaceChildren(...entries.map(({ label, value }) => {
        const item = document.createElement('div');
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        item.append(term, description);
        return item;
      }));
    }

    showStep(step, focus) {
      if (this.validationError) this.validationError.hidden = true;
      this.currentStep = step;
      this.panels.forEach((panel) => { panel.hidden = Number(panel.dataset.stepPanel) !== step; });
      this.querySelectorAll('[data-step-indicator]').forEach((indicator) => {
        if (Number(indicator.dataset.stepIndicator) === step) indicator.setAttribute('aria-current', 'step');
        else indicator.removeAttribute('aria-current');
      });
      const heading = this.querySelector(`[data-step-panel="${step}"] h2`);
      if (focus && heading) {
        heading.tabIndex = -1;
        heading.focus();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        heading.scrollIntoView({ behavior: reduceMotion ? 'instant' : 'smooth', block: 'start' });
      }
    }
  }

  if (!customElements.get('star-custom-sign')) customElements.define('star-custom-sign', StarCustomSign);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-product-compare"] && !Shopify.designMode) return;
  try {
    
  class StarProductCompare extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-compare-form]');
      this.input = this.querySelector('[data-compare-input]');
      this.submit = this.querySelector('[data-compare-submit]');
      this.status = this.querySelector('[data-compare-status]');
      this.grid = this.querySelector('[data-compare-grid]');
      this.empty = this.querySelector('[data-compare-empty]');
      this.template = this.querySelector('[data-compare-card-template]');
      this.details = this.querySelector('[data-compare-details]');
      this.tableHead = this.querySelector('[data-compare-table-head]');
      this.tableBody = this.querySelector('[data-compare-table-body]');
      this.differences = this.querySelector('[data-compare-differences]');
      this.differenceEmpty = this.querySelector('[data-compare-difference-empty]');
      this.compatibility = this.querySelector('[data-compare-compatibility]');
      this.quoteSelected = this.querySelector('[data-compare-quote]');
      this.printButton = this.querySelector('[data-compare-print]');
      this.items = [];
      this.form?.addEventListener('submit', this.handleSubmit);
      this.grid?.addEventListener('click', this.handleGridClick);
      this.differences?.addEventListener('change', this.applyDifferenceFilter);
      this.printButton?.addEventListener('click', this.printComparison);
      this.loadFromUrl();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.handleSubmit);
      this.grid?.removeEventListener('click', this.handleGridClick);
      this.differences?.removeEventListener('change', this.applyDifferenceFilter);
      this.printButton?.removeEventListener('click', this.printComparison);
    }

    async loadFromUrl() {
      const params = new URL(window.location.href).searchParams;
      const sharedSkus = (params.get('skus') || '').split(',');
      const legacySkus = params.getAll('sku');
      const skus = [...sharedSkus, ...legacySkus]
        .map((sku) => sku.trim())
        .filter((sku, index, entries) => sku && entries.indexOf(sku) === index)
        .slice(0, Number(this.dataset.maxProducts));
      const failedSkus = [];
      for (const sku of skus) {
        const itemCount = this.items.length;
        await this.addSku(sku, false);
        if (this.items.length === itemCount) failedSkus.push(sku);
      }
      if (failedSkus.length > 0 && this.items.length > 0) {
        this.setStatus(`${this.dataset.partialText} ${failedSkus.join(', ')}`, 'error', false);
      }
      this.syncUrl();
    }

    handleSubmit = async (event) => {
      event.preventDefault();
      const sku = this.input.value.trim();
      if (!sku) {
        this.setStatus(this.dataset.notFoundText, 'error', true);
        return;
      }
      await this.addSku(sku, true);
    };

    handleGridClick = (event) => {
      const button = event.target.closest('[data-remove-product]');
      if (!button) return;
      const card = button.closest('[data-variant-id]');
      this.items = this.items.filter((item) => String(item.variant.id) !== card.dataset.variantId);
      card.remove();
      this.updateState();
      this.syncUrl();
      this.input.focus();
    };

    async addSku(sku, focusStatus) {
      if (this.items.length >= Number(this.dataset.maxProducts)) {
        this.setStatus(this.dataset.limitText, 'error', focusStatus);
        return;
      }
      if (this.items.some((item) => String(item.variant.sku).toLocaleLowerCase() === sku.toLocaleLowerCase())) {
        this.setStatus(this.dataset.duplicateText, 'error', focusStatus);
        return;
      }
      this.submit.disabled = true;
      this.setStatus(this.dataset.searchingText, '', false);
      try {
        const match = await this.resolveSku(sku);
        if (!match) return;
        this.items.push(match);
        this.renderCard(match);
        this.input.value = '';
        const availability = match.variant.available ? this.dataset.availableText : this.dataset.unavailableText;
        this.setStatus(`${match.product.title} — ${availability}`, 'success', focusStatus);
        this.updateState();
        this.syncUrl();
      } catch {
        this.setStatus(this.dataset.errorText, 'error', focusStatus);
      } finally {
        this.submit.disabled = false;
      }
    }

    async resolveSku(sku) {
      const params = new URLSearchParams({
        q: sku,
        'resources[type]': 'product',
        'resources[limit]': '10',
        'resources[options][fields]': 'title,product_type,variants.title,variants.sku',
        'resources[options][unavailable_products]': 'last',
      });
      const response = await fetch(`${this.dataset.rootUrl}search/suggest.json?${params.toString()}`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error();
      const payload = await response.json();
      const results = payload.resources?.results?.products || [];
      const matches = [];
      for (const result of results) {
        const productResponse = await fetch(`${this.dataset.rootUrl}products/${encodeURIComponent(result.handle)}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!productResponse.ok) continue;
        const product = await productResponse.json();
        product.variants?.filter((variant) => String(variant.sku || '').toLocaleLowerCase() === sku.toLocaleLowerCase()).forEach((variant) => matches.push({ product, variant }));
      }
      const unique = Array.from(new Map(matches.map((item) => [String(item.variant.id), item])).values());
      if (unique.length === 0) {
        this.setStatus(this.dataset.notFoundText, 'error', true);
        return null;
      }
      if (unique.length > 1) {
        this.setStatus(this.dataset.ambiguousText, 'error', true);
        return null;
      }
      return unique[0];
    }

    renderCard(item) {
      const fragment = this.template.content.cloneNode(true);
      const card = fragment.querySelector('.star-product-compare__card');
      const productUrl = this.productUrl(item);
      card.dataset.variantId = String(item.variant.id);
      card.querySelectorAll('[data-product-link]').forEach((link) => { link.href = productUrl; });
      card.querySelector('[data-product-title]').textContent = item.product.title;
      card.querySelector('[data-product-context]').textContent = item.product.type || '';
      card.querySelector('[data-product-sku]').textContent = item.variant.sku || '—';
      card.querySelector('[data-product-option]').textContent = item.variant.public_title || item.variant.title || 'Single option';
      card.querySelector('[data-product-availability]').textContent = item.variant.available ? this.dataset.availableText : this.dataset.unavailableText;
      card.querySelector('[data-product-price]').textContent = Number(item.variant.price) > 0 ? this.money(item.variant.price) : this.dataset.priceRequestText;
      const image = card.querySelector('[data-product-image]');
      const fallback = card.querySelector('[data-product-image-fallback]');
      const imageUrl = item.variant.featured_image?.src || item.product.featured_image;
      if (imageUrl) {
        image.src = imageUrl;
        image.alt = item.product.title;
        image.hidden = false;
        fallback.hidden = true;
      }
      this.grid.append(fragment);
    }

    productUrl(item) {
      return `${this.dataset.rootUrl}products/${encodeURIComponent(item.product.handle)}?variant=${item.variant.id}`;
    }

    optionName(option) {
      return typeof option === 'string' ? option : option?.name || '';
    }

    comparisonRows() {
      const supplied = (value) => {
        const normalisedValue = String(value || '').trim();
        return normalisedValue || this.dataset.notSuppliedText;
      };
      const rows = [
        {
          label: this.dataset.skuTerm,
          values: this.items.map((item) => supplied(item.variant.sku)),
        },
        {
          label: this.dataset.productTypeTerm,
          values: this.items.map((item) => supplied(item.product.type)),
        },
        {
          label: this.dataset.optionTerm,
          values: this.items.map((item) => supplied(item.variant.public_title || item.variant.title)),
        },
        {
          label: this.dataset.availabilityTerm,
          values: this.items.map((item) =>
            item.variant.available ? this.dataset.availableText : this.dataset.unavailableText
          ),
        },
        {
          label: this.dataset.priceTerm,
          values: this.items.map((item) =>
            Number(item.variant.price) > 0 ? this.money(item.variant.price) : this.dataset.priceRequestText
          ),
        },
      ];

      const optionNames = [];
      this.items.forEach((item) => {
        (item.product.options || []).forEach((option) => {
          const name = this.optionName(option).trim();
          if (!name || name.toLocaleLowerCase() === 'title') return;
          if (!optionNames.some((entry) => entry.toLocaleLowerCase() === name.toLocaleLowerCase())) {
            optionNames.push(name);
          }
        });
      });

      optionNames.forEach((optionName) => {
        rows.push({
          label: optionName,
          values: this.items.map((item) => {
            const optionIndex = (item.product.options || []).findIndex(
              (option) => this.optionName(option).toLocaleLowerCase() === optionName.toLocaleLowerCase()
            );
            if (optionIndex < 0) return this.dataset.notSuppliedText;
            return supplied(item.variant.options?.[optionIndex] || item.variant[`option${optionIndex + 1}`]);
          }),
        });
      });

      return rows;
    }

    renderComparisonTable() {
      const canCompare = this.items.length >= 2;
      this.details.hidden = !canCompare;
      this.tableHead.textContent = '';
      this.tableBody.textContent = '';

      if (!canCompare) {
        this.compatibility.hidden = true;
        this.differenceEmpty.hidden = true;
        return;
      }

      const headerRow = document.createElement('tr');
      const factHeading = document.createElement('th');
      factHeading.scope = 'col';
      factHeading.textContent = this.dataset.factColumnLabel;
      headerRow.append(factHeading);

      this.items.forEach((item) => {
        const heading = document.createElement('th');
        const link = document.createElement('a');
        heading.scope = 'col';
        link.href = this.productUrl(item);
        link.textContent = item.product.title;
        heading.append(link);
        headerRow.append(heading);
      });
      this.tableHead.append(headerRow);

      this.comparisonRows().forEach((rowData) => {
        const row = document.createElement('tr');
        const label = document.createElement('th');
        const normalisedValues = rowData.values.map((value) => value.trim().toLocaleLowerCase());
        row.dataset.different = String(new Set(normalisedValues).size > 1);
        label.scope = 'row';
        label.textContent = rowData.label;
        row.append(label);
        rowData.values.forEach((value) => {
          const cell = document.createElement('td');
          cell.textContent = value;
          row.append(cell);
        });
        this.tableBody.append(row);
      });

      const productTypes = this.items
        .map((item) => String(item.product.type || '').trim().toLocaleLowerCase())
        .filter(Boolean);
      const hasDifferentTypes = new Set(productTypes).size > 1;
      this.compatibility.textContent = hasDifferentTypes ? this.dataset.differentTypesText : '';
      this.compatibility.hidden = !hasDifferentTypes;
      this.applyDifferenceFilter();
      this.updateQuoteLink();
    }

    updateQuoteLink() {
      if (!this.quoteSelected) return;
      const url = new URL(this.quoteSelected.dataset.baseUrl, window.location.origin);
      url.searchParams.set('product', this.items.map((item) => item.product.title).join(' | '));
      url.searchParams.set('sku', this.items.map((item) => item.variant.sku).filter(Boolean).join(', '));
      this.quoteSelected.href = url.toString();
    }

    printComparison = () => {
      window.print();
    };

    applyDifferenceFilter = () => {
      const onlyDifferences = Boolean(this.differences?.checked);
      let visibleRows = 0;
      this.tableBody?.querySelectorAll('tr').forEach((row) => {
        const hidden = onlyDifferences && row.dataset.different !== 'true';
        row.hidden = hidden;
        if (!hidden) visibleRows += 1;
      });
      if (this.differenceEmpty) {
        this.differenceEmpty.hidden = !onlyDifferences || visibleRows > 0;
      }
    };

    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency: this.dataset.currency,
      }).format(Number(cents) / 100);
    }

    setStatus(message, state, focus) {
      this.status.textContent = message;
      if (state) this.status.dataset.state = state; else delete this.status.dataset.state;
      if (focus) this.status.focus();
    }

    updateState() {
      const hasItems = this.items.length > 0;
      this.empty.hidden = hasItems;
      this.grid.hidden = !hasItems;
      this.renderComparisonTable();
    }

    syncUrl() {
      const url = new URL(window.location.href);
      url.searchParams.delete('sku');
      url.searchParams.delete('skus');
      if (this.items.length > 0) {
        url.searchParams.set('skus', this.items.map((item) => item.variant.sku).join(','));
      }
      window.history.replaceState({}, '', url);
    }
  }

  if (!customElements.get('star-product-compare')) customElements.define('star-product-compare', StarProductCompare);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-product-finder"] && !Shopify.designMode) return;
  try {
    
  class StarProductFinder extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-finder-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-finder-panel]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleClick);
        tab.addEventListener('keydown', this.handleKeydown);
      });

      const requested = new URL(window.location.href).searchParams.get('finder');
      if (this.tabs.some((tab) => tab.dataset.finderTab === requested)) this.activate(requested, false);
    }

    disconnectedCallback() {
      this.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.handleClick);
        tab.removeEventListener('keydown', this.handleKeydown);
      });
    }

    handleClick = (event) => {
      this.activate(event.currentTarget.dataset.finderTab, true);
    };

    handleKeydown = (event) => {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === currentIndex) return;
      event.preventDefault();
      this.tabs[nextIndex].focus();
      this.activate(this.tabs[nextIndex].dataset.finderTab, true);
    };

    activate(key, updateUrl) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.finderTab === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.finderPanel !== key;
      });

      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('finder', key);
        window.history.replaceState({}, '', url);
      }
    }
  }

  if (!customElements.get('star-product-finder')) {
    customElements.define('star-product-finder', StarProductFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-quick-order-browse"] && !Shopify.designMode) return;
  try {
    
  class StarQuickOrderBrowse extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-browse-category]');
      this.filter = this.querySelector('[data-browse-filter]');
      this.status = this.querySelector('[data-browse-status]');
      this.grid = this.querySelector('[data-browse-grid]');
      this.more = this.querySelector('[data-browse-more]');
      this.open = this.querySelector('[data-browse-open]');
      this.toList = this.querySelector('[data-browse-to-list]');
      this.count = this.querySelector('[data-browse-count]');
      this.cardTemplate = this.querySelector('[data-browse-card]');
      this.pageSize = Number(this.dataset.pageSize) || 24;
      this.added = 0;
      this.select.addEventListener('change', () => this.load(this.select.value, 1, true));
      this.filter.addEventListener('input', () => this.applyFilter());
      this.more.addEventListener('click', () => this.load(this.handle, this.page + 1, false));
      const wanted = new URL(window.location.href).searchParams.get('category');
      if (wanted && [...this.select.options].some((o) => o.value === wanted)) {
        this.select.value = wanted;
        this.load(wanted, 1, true);
      }
    }

    text(name) {
      const el = this.querySelector(`[data-text-${name}]`);
      return el ? el.textContent.trim() : '';
    }

    money(amount) {
      return new Intl.NumberFormat('en-AU', {           // "$2.68" as on the rest of the site (plain 'en' prints "A$")
        style: 'currency',
        currency: this.dataset.currency || 'AUD',
      }).format(amount);
    }

    async load(handle, page, reset) {
      this.handle = handle;
      if (reset) {
        this.grid.replaceChildren();
        this.filter.value = '';
        const url = new URL(window.location.href);
        if (handle) url.searchParams.set('category', handle);
        else url.searchParams.delete('category');
        window.history.replaceState({}, '', url);
      }
      this.more.hidden = true;
      this.open.hidden = !handle;
      if (handle) this.open.href = `${this.dataset.rootUrl}collections/${encodeURIComponent(handle)}`;
      if (!handle) {
        this.filter.disabled = true;
        this.status.textContent = '';
        return;
      }
      this.status.textContent = this.text('loading');
      const token = (this.token = Symbol('load'));
      try {
        const response = await fetch(
          `${this.dataset.rootUrl}collections/${encodeURIComponent(handle)}/products.json?limit=${this.pageSize}&page=${page}`,
          { headers: { Accept: 'application/json' } }
        );
        if (!response.ok) throw new Error(String(response.status));
        const data = await response.json();
        if (token !== this.token) return;
        const products = (data.products || []).filter(
          (p) => String(p.product_type || '').trim().toLowerCase() !== 'training course'
        );
        products.forEach((p) => this.grid.append(this.card(p)));
        this.page = page;
        this.more.hidden = (data.products || []).length < this.pageSize;
        this.filter.disabled = false;
        const shown = this.grid.children.length;
        this.status.textContent = shown ? this.text('count').replace('[count]', shown) : this.text('empty');
        this.applyFilter();
      } catch (error) {
        if (token === this.token) this.status.textContent = this.text('error');
      }
    }

    card(product) {
      const node = this.cardTemplate.content.firstElementChild.cloneNode(true);
      const url = `${this.dataset.rootUrl}products/${product.handle}`;
      const link = node.querySelector('[data-card-link]');
      const title = node.querySelector('[data-card-title]');
      const img = node.querySelector('[data-card-img]');
      const variantSelect = node.querySelector('[data-card-variant]');
      const qty = node.querySelector('[data-card-qty]');
      const add = node.querySelector('[data-card-add]');
      const note = node.querySelector('[data-card-note]');
      const uid = `QOB-${product.id}`;
      link.href = url;
      title.href = url;
      title.textContent = product.title;
      node.dataset.search = `${product.title} ${product.vendor} ${(product.variants || []).map((v) => v.sku || '').join(' ')}`.toLowerCase();
      node.querySelector('[data-card-vendor]').textContent = product.vendor || '';
      const image = (product.images || [])[0];
      if (image && image.src) img.src = `${image.src}${image.src.includes('?') ? '&' : '?'}width=200`;
      else img.remove();
      variantSelect.id = `${uid}-variant`;
      qty.id = `${uid}-qty`;
      node.querySelector('[data-card-variant-label]').htmlFor = variantSelect.id;
      node.querySelector('[data-card-qty-label]').htmlFor = qty.id;
      const variants = product.variants || [];
      variants.forEach((v) => {
        const option = document.createElement('option');
        option.value = String(v.id);
        option.textContent = `${v.title === 'Default Title' ? product.title : v.title}${v.sku ? ` (${v.sku})` : ''}`;
        variantSelect.append(option);
      });
      if (variants.length < 2) {
        variantSelect.hidden = true;
        variantSelect.previousElementSibling.hidden = true;
      }
      const refresh = () => {
        const v = variants.find((x) => String(x.id) === variantSelect.value) || variants[0];
        node.querySelector('[data-card-price]').replaceChildren(...this.priceNodes(v));
        add.disabled = !v || !v.sku || !v.available;
        note.dataset.state = '';
        note.textContent = !v ? '' : !v.sku ? this.text('nosku') : !v.available ? this.text('out') : '';
        if (!v || !v.sku || !v.available) note.dataset.state = 'error';
      };
      variantSelect.addEventListener('change', refresh);
      add.addEventListener('click', () => {
        const v = variants.find((x) => String(x.id) === variantSelect.value) || variants[0];
        this.addToList(v, Math.max(1, Math.min(999, Math.round(Number(qty.value) || 1))), note);
      });
      refresh();
      return node;
    }

    priceNodes(v) {
      const price = Number(v && v.price);
      if (!Number.isFinite(price) || price <= 0) return [document.createTextNode(this.text('request'))];
      const strong = document.createElement('strong');
      strong.textContent = `${this.money(price / 1.1)} ${this.text('ex')}`;
      const small = document.createElement('small');
      small.textContent = ` ${this.money(price)} ${this.text('inc')}`;
      return [strong, small];
    }

    addToList(variant, quantity, note) {
      const order = document.querySelector('star-quick-order');
      if (!order || !variant || !variant.sku) return;
      const rows = [...order.querySelectorAll('[data-quick-order-row]')];
      let row = rows.find((r) => !r.querySelector('[data-quick-order-sku]').value.trim());
      if (!row && typeof order.appendRow === 'function') row = order.appendRow();
      if (!row) {
        note.dataset.state = 'error';
        note.textContent = this.text('full');
        return;
      }
      const sku = row.querySelector('[data-quick-order-sku]');
      const qty = row.querySelector('[data-quick-order-quantity]');
      sku.value = variant.sku;
      qty.value = String(quantity);
      sku.dispatchEvent(new Event('input', { bubbles: true }));
      qty.dispatchEvent(new Event('input', { bubbles: true }));
      if (typeof order.setStatus === 'function') order.setStatus(row, this.text('ready'), '');
      this.added += 1;
      note.dataset.state = '';
      note.textContent = this.text('added');
      this.count.textContent = String(this.added);
      this.toList.hidden = false;
      if (!this.toList.dataset.bound) {
        this.toList.dataset.bound = '1';
        this.toList.addEventListener('click', (event) => {
          const form = document.querySelector('star-quick-order [data-quick-order-form]');
          if (!form) return;
          event.preventDefault();
          form.scrollIntoView({ behavior: 'smooth', block: 'start' });
          form.querySelector('[data-quick-order-submit]')?.focus({ preventScroll: true });
        });
      }
    }

    applyFilter() {
      const q = this.filter.value.trim().toLowerCase();
      let shown = 0;
      [...this.grid.children].forEach((card) => {
        card.hidden = Boolean(q) && !card.dataset.search.includes(q);
        if (!card.hidden) shown += 1;
      });
      if (this.handle && this.grid.children.length) {
        this.status.textContent = shown ? this.text('count').replace('[count]', shown) : this.text('empty');
      }
    }
  }

  if (!customElements.get('star-quick-order-browse')) {
    customElements.define('star-quick-order-browse', StarQuickOrderBrowse);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-quick-order"] && !Shopify.designMode) return;
  try {
    
  class StarQuickOrder extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-quick-order-form]');
      this.rows = this.querySelector('[data-quick-order-rows]');
      this.template = this.querySelector('[data-quick-order-template]');
      this.addRowButton = this.querySelector('[data-quick-order-add-row]');
      this.submitButton = this.querySelector('[data-quick-order-submit]');
      this.summary = this.querySelector('[data-quick-order-summary]');
      this.viewCart = this.querySelector('[data-quick-order-view-cart]');
      this.pasteInput = this.querySelector('[data-quick-order-paste]');
      this.csvInput = this.querySelector('[data-quick-order-csv]');
      this.applyPasteButton = this.querySelector('[data-quick-order-apply-paste]');
      this.importCsvButton = this.querySelector('[data-quick-order-apply-csv]');
      this.importStatus = this.querySelector('[data-quick-order-import-status]');
      this.rowSequence = this.querySelectorAll('[data-quick-order-row]').length;
      this.addRowButton?.addEventListener('click', this.addRow);
      this.applyPasteButton?.addEventListener('click', this.handleApplyPaste);
      this.importCsvButton?.addEventListener('click', this.handleApplyCsv);
      this.form?.addEventListener('click', this.handleClick);
      this.form?.addEventListener('input', this.handleInput);
      this.form?.addEventListener('submit', this.handleSubmit);
      this.rows?.querySelectorAll('[data-quick-order-row]').forEach((row) => this.prepareRow(row));
      this.updateAddRowAvailability();
    }

    disconnectedCallback() {
      this.addRowButton?.removeEventListener('click', this.addRow);
      this.applyPasteButton?.removeEventListener('click', this.handleApplyPaste);
      this.importCsvButton?.removeEventListener('click', this.handleApplyCsv);
      this.form?.removeEventListener('click', this.handleClick);
      this.form?.removeEventListener('input', this.handleInput);
      this.form?.removeEventListener('submit', this.handleSubmit);
    }

    addRow = () => {
      this.appendRow({ focus: true });
    };

    appendRow({ focus = false } = {}) {
      if (!this.template || !this.rows || this.rows.querySelectorAll('[data-quick-order-row]').length >= 50) {
        this.updateAddRowAvailability();
        return null;
      }

      this.rowSequence += 1;
      const fragment = this.template.content.cloneNode(true);
      const row = fragment.querySelector('[data-quick-order-row]');
      const skuInput = fragment.querySelector('[data-quick-order-sku]');
      const quantityInput = fragment.querySelector('[data-quick-order-quantity]');
      const skuLabel = fragment.querySelector('[data-quick-order-sku-label]');
      const quantityLabel = fragment.querySelector('[data-quick-order-quantity-label]');
      const skuId = `QuickOrderSku-${this.id || 'section'}-${this.rowSequence}`;
      const quantityId = `QuickOrderQuantity-${this.id || 'section'}-${this.rowSequence}`;
      skuInput.id = skuId;
      quantityInput.id = quantityId;
      skuLabel.htmlFor = skuId;
      quantityLabel.htmlFor = quantityId;
      skuLabel.textContent = `${skuLabel.textContent.trim()} ${this.rowSequence}`;
      quantityLabel.textContent = `${quantityLabel.textContent.trim()} ${this.rowSequence}`;
      this.rows.append(fragment);
      this.prepareRow(row);
      this.updateAddRowAvailability();
      if (focus) skuInput.focus();
      return row;
    }

    updateAddRowAvailability() {
      if (!this.addRowButton || !this.rows) return;
      this.addRowButton.disabled = this.rows.querySelectorAll('[data-quick-order-row]').length >= 50;
    }

    prepareRow(row) {
      const quantityInput = row.querySelector('[data-quick-order-quantity]');
      const status = row.querySelector('[data-quick-order-status]');
      if (!quantityInput || !status || !quantityInput.id) return;
      status.id = status.id || `${quantityInput.id}-Status`;
      quantityInput.setAttribute('aria-describedby', status.id);
    }

    handleInput = (event) => {
      const row = event.target.closest('[data-quick-order-row]');
      if (!row) return;

      if (event.target.matches('[data-quick-order-sku]')) {
        this.resetRowState(row, { resetQuantityRule: true });
        return;
      }

      if (event.target.matches('[data-quick-order-quantity]')) {
        this.clearQuantityError(row);
        delete row.dataset.variantId;
        this.setStatus(row, '', '');
      }
    };

    handleClick = (event) => {
      const removeButton = event.target.closest('[data-quick-order-remove]');
      if (!removeButton) return;
      const row = removeButton.closest('[data-quick-order-row]');
      const allRows = Array.from(this.rows.querySelectorAll('[data-quick-order-row]'));
      if (allRows.length === 1) {
        row.querySelector('[data-quick-order-sku]').value = '';
        row.querySelector('[data-quick-order-quantity]').value = '1';
        this.resetRowState(row, { resetQuantityRule: true });
        row.querySelector('[data-quick-order-sku]')?.focus();
        return;
      }

      const rowIndex = allRows.indexOf(row);
      const focusRow = allRows[rowIndex + 1] || allRows[rowIndex - 1];
      row.remove();
      this.updateAddRowAvailability();
      focusRow?.querySelector('[data-quick-order-sku]')?.focus();
    };

    handleApplyPaste = () => {
      if (!this.pasteInput) return;
      this.pasteInput.removeAttribute('aria-invalid');

      if (!this.pasteInput.value.trim()) {
        this.pasteInput.setAttribute('aria-invalid', 'true');
        this.announceImport(this.dataset.importEmptyText, 'error', true);
        return;
      }

      const result = this.importRecords(this.parsePastedRecords(this.pasteInput.value));
      if (result.applied > 0 && result.invalidLines.length === 0 && result.truncated === 0) {
        this.pasteInput.value = '';
      }
    };

    handleApplyCsv = async () => {
      if (!this.csvInput || !this.importCsvButton) return;
      this.csvInput.removeAttribute('aria-invalid');
      const file = this.csvInput.files?.[0];

      if (!file) {
        this.csvInput.setAttribute('aria-invalid', 'true');
        this.announceImport(this.dataset.importFileRequiredText, 'error', true);
        return;
      }

      if (!file.name.toLocaleLowerCase().endsWith('.csv') || file.size > 2 * 1024 * 1024) {
        this.csvInput.setAttribute('aria-invalid', 'true');
        this.announceImport(this.dataset.importFileErrorText, 'error', true);
        return;
      }

      this.importCsvButton.disabled = true;

      try {
        const result = this.importRecords(this.parseCsvRecords(await file.text()));
        if (result.applied > 0 && result.invalidLines.length === 0 && result.truncated === 0) {
          this.csvInput.value = '';
        }
      } catch (error) {
        this.csvInput.setAttribute('aria-invalid', 'true');
        this.announceImport(this.dataset.importReadErrorText, 'error', true);
      } finally {
        this.importCsvButton.disabled = false;
      }
    };

    parsePastedRecords(text) {
      return String(text)
        .replace(/^\uFEFF/, '')
        .split(/\r?\n/)
        .flatMap((line, index) => {
          if (!line.trim()) return [];

          let fields;
          if (line.includes('\t')) {
            fields = line.split('\t');
          } else if (!line.includes(',') && line.includes(';')) {
            fields = line.split(';');
          } else {
            fields = this.parseCsvRecords(line)[0]?.fields || [line];
          }

          return [{ fields, line: index + 1 }];
        });
    }

    parseCsvRecords(text) {
      const source = String(text).replace(/^\uFEFF/, '');
      const records = [];
      let fields = [];
      let field = '';
      let inQuotes = false;
      let lineNumber = 1;
      let recordLine = 1;

      const finishRecord = () => {
        fields.push(field);
        if (fields.some((value) => value.trim().length > 0)) {
          records.push({ fields, line: recordLine });
        }
        fields = [];
        field = '';
      };

      for (let index = 0; index < source.length; index += 1) {
        const character = source[index];

        if (inQuotes) {
          if (character === '"' && source[index + 1] === '"') {
            field += '"';
            index += 1;
          } else if (character === '"') {
            inQuotes = false;
          } else {
            field += character;
            if (character === '\n') lineNumber += 1;
          }
          continue;
        }

        if (character === '"' && field.length === 0) {
          inQuotes = true;
        } else if (character === ',') {
          fields.push(field);
          field = '';
        } else if (character === '\r' || character === '\n') {
          finishRecord();
          if (character === '\r' && source[index + 1] === '\n') index += 1;
          lineNumber += 1;
          recordLine = lineNumber;
        } else {
          field += character;
        }
      }

      if (field.length > 0 || fields.length > 0) finishRecord();
      return records;
    }

    importRecords(records) {
      const { entries, invalidLines } = this.normaliseRecords(records);

      if (entries.length === 0) {
        const message = invalidLines.length > 0
          ? `${this.dataset.importInvalidText} ${this.formatLineList(invalidLines)}.`
          : this.dataset.importEmptyText;
        this.announceImport(message, 'error', true);
        return { applied: 0, invalidLines, truncated: 0 };
      }

      const { applied, truncated } = this.populateRows(entries);
      const messages = [];
      if (applied > 0) messages.push(`${applied} ${this.dataset.importAppliedText}`);
      if (invalidLines.length > 0) {
        messages.push(`${this.dataset.importInvalidText} ${this.formatLineList(invalidLines)}.`);
      }
      if (truncated > 0) messages.push(this.dataset.importLimitText);

      const hasWarning = invalidLines.length > 0 || truncated > 0;
      this.announceImport(messages.join(' '), hasWarning ? 'warning' : 'success', applied === 0);
      return { applied, invalidLines, truncated };
    }

    normaliseRecords(records) {
      const candidates = Array.from(records);
      const entries = [];
      const invalidLines = [];

      if (candidates[0] && this.isHeaderRow(candidates[0].fields)) candidates.shift();

      candidates.forEach((record) => {
        const sku = String(record.fields[0] || '').trim();
        const quantityText = String(record.fields[1] || '').trim();
        const quantity = Number(quantityText);
        const validQuantity = /^\d+$/.test(quantityText)
          && Number.isSafeInteger(quantity)
          && quantity >= 1
          && quantity <= 999;

        if (!sku || !validQuantity) {
          invalidLines.push(record.line);
          return;
        }

        entries.push({ sku, quantity });
      });

      return { entries, invalidLines };
    }

    isHeaderRow(fields) {
      const normalise = (value) => String(value || '')
        .trim()
        .toLocaleLowerCase()
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ');
      const skuHeadings = ['sku', 'product sku', 'variant sku', 'item sku', 'product code'];
      const quantityHeadings = ['quantity', 'qty', 'order quantity'];
      return skuHeadings.includes(normalise(fields[0])) && quantityHeadings.includes(normalise(fields[1]));
    }

    populateRows(entries) {
      const blankRows = Array.from(this.rows.querySelectorAll('[data-quick-order-row]')).filter((row) => {
        return row.querySelector('[data-quick-order-sku]').value.trim().length === 0;
      });
      let applied = 0;

      entries.forEach((entry) => {
        const row = blankRows.shift() || this.appendRow();
        if (!row) return;
        row.querySelector('[data-quick-order-sku]').value = entry.sku;
        row.querySelector('[data-quick-order-quantity]').value = String(entry.quantity);
        this.resetRowState(row, { resetQuantityRule: true });
        applied += 1;
      });

      return { applied, truncated: entries.length - applied };
    }

    formatLineList(lines) {
      const shownLines = lines.slice(0, 8).join(', ');
      const remaining = lines.length - 8;
      return remaining > 0 ? `${shownLines} (+${remaining})` : shownLines;
    }

    announceImport(message, state, shouldFocus = false) {
      if (!this.importStatus) return;
      this.importStatus.textContent = message;
      this.importStatus.dataset.state = state;
      if (shouldFocus) this.importStatus.focus();
    }

    handleSubmit = async (event) => {
      event.preventDefault();
      const rows = Array.from(this.rows.querySelectorAll('[data-quick-order-row]')).filter((row) => {
        return row.querySelector('[data-quick-order-sku]').value.trim().length > 0;
      });

      if (rows.length === 0) {
        this.summary.textContent = this.dataset.notFoundText;
        this.rows.querySelector('[data-quick-order-sku]')?.focus();
        return;
      }

      this.submitButton.disabled = true;
      this.viewCart.hidden = true;
      this.summary.textContent = this.dataset.searchingText;

      try {
        const cartQuantities = await this.fetchCartQuantities();
        const lookupCache = this.createLookupCache();
        const resolved = await this.resolveRows(rows, cartQuantities, lookupCache);
        const itemMap = new Map();
        resolved.filter(Boolean).forEach((item) => {
          const key = String(item.id);
          const current = itemMap.get(key) || {
            id: item.id,
            quantity: 0,
            cartQuantity: item.cartQuantity,
            rule: item.rule,
            rows: [],
          };
          current.quantity += item.quantity;
          current.rows.push(item.row);
          itemMap.set(key, current);
        });
        const items = [];

        itemMap.forEach((item) => {
          const quantityError = this.getQuantityError(item.quantity, item.rule, item.cartQuantity);
          if (quantityError) {
            const combinedError = item.rows.length > 1
              ? `${this.formatTemplate(this.dataset.quantityCombinedErrorText, { quantity: item.quantity })} ${quantityError}`
              : quantityError;
            item.rows.forEach((row) => this.setQuantityError(row, combinedError));
            return;
          }
          items.push({ id: item.id, quantity: item.quantity });
        });

        const hasPriceRequestRows = rows.some((row) => row.dataset.priceRequest === 'true');
        const hasQuantityErrors = rows.some((row) => row.dataset.quantityInvalid === 'true');

        if (items.length === 0) {
          if (hasQuantityErrors) {
            this.summary.textContent = this.dataset.quantityReviewText;
            rows.find((row) => row.dataset.quantityInvalid === 'true')
              ?.querySelector('[data-quick-order-quantity]')
              ?.focus();
          } else {
            if (rows.some((row) => row.dataset.courseBooking === 'true')) {
              this.summary.textContent = this.courseSummaryText;
            } else {
              this.summary.textContent = hasPriceRequestRows
                ? this.dataset.priceRequestSummaryText
                : this.dataset.notFoundText;
            }
          }
          return;
        }

        const response = await fetch(`${this.dataset.rootUrl}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) throw new Error(this.dataset.errorText);

        const cartResponse = await fetch(`${this.dataset.rootUrl}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!cartResponse.ok) throw new Error(this.dataset.errorText);
        const ajaxCart = await cartResponse.json();

        rows.forEach((row) => {
          if (row.dataset.variantId) this.setStatus(row, this.dataset.addedText, 'success');
        });
        this.summary.textContent = `${items.length} ${this.dataset.addedText}${
          hasQuantityErrors ? ` ${this.dataset.quantitySkippedText}` : ''
        }`;
        this.viewCart.hidden = false;
        this.dispatchEvent(
          new CustomEvent('star:quick-order:cart-added', {
            bubbles: true,
            detail: { cart: ajaxCart, items },
          })
        );
      } catch (error) {
        this.summary.textContent = error.message || this.dataset.errorText;
      } finally {
        this.submitButton.disabled = false;
      }
    };

    async fetchCartQuantities() {
      const response = await fetch(`${this.dataset.rootUrl}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error(this.dataset.errorText);

      const ajaxCart = await response.json();
      const quantities = new Map();
      (ajaxCart.items || []).forEach((item) => {
        const key = String(item.variant_id || item.id);
        quantities.set(key, (quantities.get(key) || 0) + Number(item.quantity || 0));
      });
      return quantities;
    }

    createLookupCache() {
      return {
        skuPromises: new Map(),
        productPromises: new Map(),
      };
    }

    async resolveRows(rows, cartQuantities, lookupCache = this.createLookupCache()) {
      const results = new Array(rows.length);
      let nextIndex = 0;
      const workerCount = Math.min(4, rows.length);
      const workers = Array.from({ length: workerCount }, async () => {
        while (nextIndex < rows.length) {
          const currentIndex = nextIndex;
          nextIndex += 1;
          results[currentIndex] = await this.resolveRow(rows[currentIndex], cartQuantities, lookupCache);
        }
      });

      await Promise.all(workers);
      return results;
    }

    async resolveRow(row, cartQuantities = new Map(), lookupCache = this.createLookupCache()) {
      const sku = row.querySelector('[data-quick-order-sku]').value.trim();
      const quantityInput = row.querySelector('[data-quick-order-quantity]');
      this.setStatus(row, this.dataset.searchingText, '');
      delete row.dataset.courseBooking;
      delete row.dataset.variantId;
      delete row.dataset.priceRequest;
      this.clearQuantityError(row);

      const lookup = await this.lookupSku(sku, lookupCache);
      if (lookup.state === 'error') {
        this.setStatus(row, this.dataset.errorText, 'error');
        return null;
      }
      if (lookup.state === 'not-found') {
        this.setStatus(row, this.dataset.notFoundText, 'error');
        return null;
      }
      if (lookup.state === 'ambiguous') {
        this.setStatus(row, this.dataset.ambiguousText, 'error');
        return null;
      }

      const { product, variant } = lookup;
      // A course needs the booking phone, which is entered on the course page; it is not added from here.
      if (String(product.type || '').trim().toLowerCase() === 'training course') {
        this.setCourseStatus(row, product);
        return null;
      }
      const quantityRule = this.normaliseQuantityRule(variant.quantity_rule);
      const cartQuantity = cartQuantities.get(String(variant.id)) || 0;
      this.applyQuantityRule(row, quantityRule, cartQuantity);
      const variantPrice = Number(variant.price);
      if (!Number.isFinite(variantPrice) || variantPrice <= 0) {
        this.setPriceRequestStatus(row, product, variant);
        return null;
      }
      if (!variant.available) {
        this.setStatus(row, `${product.title} — ${this.dataset.unavailableText}`, 'error');
        return null;
      }
      const quantity = Number(quantityInput.value);
      const quantityError = this.getQuantityError(quantity, quantityRule, cartQuantity);
      if (quantityError) {
        this.setQuantityError(row, quantityError);
        return null;
      }

      row.dataset.variantId = String(variant.id);
      this.setStatus(row, `${product.title} — ${variant.title} — ${this.formatMoney(variant.price)}`, 'success');
      const hasQuantityRules = quantityRule.min > 1 || quantityRule.increment > 1 || quantityRule.max !== null;
      if (hasQuantityRules) {
        const productStatus = row.querySelector('[data-quick-order-status]').textContent;
        this.setStatus(row, `${productStatus}. ${this.describeQuantityRule(quantityRule)}`, 'success');
      }
      return { id: variant.id, quantity, rule: quantityRule, cartQuantity, row };
    }

    lookupSku(sku, lookupCache) {
      const key = sku.toLocaleLowerCase();
      if (!lookupCache.skuPromises.has(key)) {
        const lookupPromise = this.fetchSkuLookup(sku, lookupCache).catch(() => ({ state: 'error' }));
        lookupCache.skuPromises.set(key, lookupPromise);
      }
      return lookupCache.skuPromises.get(key);
    }

    async fetchSkuLookup(sku, lookupCache) {
      const params = new URLSearchParams({
        q: sku,
        'resources[type]': 'product',
        'resources[limit]': '10',
        'resources[options][fields]': 'title,product_type,variants.title,variants.sku',
        'resources[options][unavailable_products]': 'last',
      });
      // The search answers 429 under load and, now and then, an empty list for a SKU it does hold.
      // Ask up to three times before a row is told "not found".
      let products = [];
      let rateLimited = false;
      for (let attempt = 0; attempt < 3; attempt += 1) {
        if (attempt > 0) await new Promise((resolve) => setTimeout(resolve, 600 * attempt));
        const response = await fetch(`${this.dataset.rootUrl}search/suggest.json?${params.toString()}`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });

        rateLimited = response.status === 429;
        if (rateLimited) continue;
        if (!response.ok) {
          return { state: 'error' };
        }

        const payload = await response.json();
        products = payload.resources?.results?.products || [];
        if (products.length > 0) break;
      }
      if (rateLimited) {
        return { state: 'error' };
      }
      const exactMatches = [];

      for (const productResult of products) {
        const product = await this.fetchProductByHandle(productResult.handle, lookupCache);
        if (!product) continue;
        const matchingVariants = product.variants?.filter(
          (candidate) => String(candidate.sku || '').toLocaleLowerCase() === sku.toLocaleLowerCase()
        );
        matchingVariants?.forEach((variant) => exactMatches.push({ product, variant }));
      }

      const uniqueMatches = Array.from(
        new Map(exactMatches.map((match) => [String(match.variant.id), match])).values()
      );
      if (uniqueMatches.length === 0) {
        return { state: 'not-found' };
      }
      if (uniqueMatches.length > 1) {
        return { state: 'ambiguous' };
      }

      const { product, variant } = uniqueMatches[0];
      return { state: 'match', product, variant };
    }

    fetchProductByHandle(handle, lookupCache) {
      const key = String(handle);
      if (!lookupCache.productPromises.has(key)) {
        const productPromise = fetch(`${this.dataset.rootUrl}products/${encodeURIComponent(handle)}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        }).then((response) => {
          if (!response.ok) return null;
          return response.json();
        });
        lookupCache.productPromises.set(key, productPromise);
      }
      return lookupCache.productPromises.get(key);
    }

    normaliseQuantityRule(quantityRule) {
      const minimum = Number(quantityRule?.min);
      const increment = Number(quantityRule?.increment);
      const maximum = quantityRule?.max === null || quantityRule?.max === undefined
        ? null
        : Number(quantityRule.max);

      return {
        min: Number.isSafeInteger(minimum) && minimum > 0 ? minimum : 1,
        increment: Number.isSafeInteger(increment) && increment > 0 ? increment : 1,
        max: Number.isSafeInteger(maximum) && maximum > 0 ? maximum : null,
      };
    }

    applyQuantityRule(row, quantityRule, cartQuantity) {
      const quantityInput = row.querySelector('[data-quick-order-quantity]');
      quantityInput.min = String(quantityRule.min);
      quantityInput.step = String(quantityRule.increment);
      quantityInput.dataset.cartQuantity = String(cartQuantity);

      if (quantityRule.max === null) {
        quantityInput.removeAttribute('max');
      } else {
        quantityInput.max = String(quantityRule.max);
      }
    }

    getQuantityError(quantity, quantityRule, cartQuantity = 0) {
      const isWholeNumber = Number.isSafeInteger(quantity);
      const followsMinimum = isWholeNumber && quantity >= quantityRule.min;
      const followsIncrement = followsMinimum && (quantity - quantityRule.min) % quantityRule.increment === 0;

      if (!isWholeNumber || !followsMinimum || !followsIncrement) {
        return this.formatTemplate(this.dataset.quantityErrorText, {
          rules: this.describeQuantityRule(quantityRule),
        });
      }

      if (quantityRule.max !== null && cartQuantity + quantity > quantityRule.max) {
        return this.formatTemplate(this.dataset.quantityCartErrorText, {
          cart_quantity: cartQuantity,
          quantity,
          maximum: quantityRule.max,
        });
      }

      return '';
    }

    describeQuantityRule(quantityRule) {
      const maximum = quantityRule.max === null
        ? ''
        : `, ${this.formatTemplate(this.dataset.quantityMaximumText, { maximum: quantityRule.max })}`;
      return this.formatTemplate(this.dataset.quantityRulesText, {
        minimum: quantityRule.min,
        increment: quantityRule.increment,
        maximum,
      });
    }

    formatTemplate(template, values) {
      return Object.entries(values).reduce(
        (output, [key, value]) => output.replaceAll(`[${key}]`, String(value)),
        String(template || '')
      );
    }

    setQuantityError(row, message) {
      const quantityInput = row.querySelector('[data-quick-order-quantity]');
      quantityInput.setCustomValidity(message);
      quantityInput.setAttribute('aria-invalid', 'true');
      row.dataset.quantityInvalid = 'true';
      delete row.dataset.variantId;
      this.setStatus(row, message, 'error');
    }

    clearQuantityError(row) {
      const quantityInput = row.querySelector('[data-quick-order-quantity]');
      quantityInput.setCustomValidity('');
      quantityInput.removeAttribute('aria-invalid');
      delete row.dataset.quantityInvalid;
    }

    setStatus(row, text, state) {
      const status = row.querySelector('[data-quick-order-status]');
      status.textContent = text;
      if (state) {
        status.dataset.state = state;
      } else {
        delete status.dataset.state;
      }
    }

    resetRowState(row, { resetQuantityRule = false } = {}) {
      delete row.dataset.variantId;
      delete row.dataset.priceRequest;
      this.clearQuantityError(row);
      if (resetQuantityRule) {
        const quantityInput = row.querySelector('[data-quick-order-quantity]');
        quantityInput.min = '1';
        quantityInput.max = '999';
        quantityInput.step = '1';
        delete quantityInput.dataset.cartQuantity;
      }
      this.setStatus(row, '', '');
    }

    setPriceRequestStatus(row, product, variant) {
      const status = row.querySelector('[data-quick-order-status]');
      const productLabel = document.createElement('span');
      const quoteLink = document.createElement('a');
      const quoteParams = new URLSearchParams({ product: product.title });

      if (variant.sku) quoteParams.set('sku', variant.sku);

      productLabel.textContent = `${product.title} — ${variant.title} — ${this.dataset.priceRequestText}`;
      quoteLink.className = 'star-quick-order__quote-link';
      quoteLink.href = `${this.dataset.quoteUrl}?${quoteParams.toString()}`;
      quoteLink.textContent = this.dataset.requestQuoteText;
      status.replaceChildren(productLabel, quoteLink);
      status.dataset.state = 'price-request';
      row.dataset.priceRequest = 'true';
    }

    get courseSummaryText() {
      return this.dataset.courseSummaryText || 'Training courses are booked on their course page and were not added to cart.';
    }

    setCourseStatus(row, product) {
      const status = row.querySelector('[data-quick-order-status]');
      const courseLabel = document.createElement('span');
      const courseLink = document.createElement('a');

      courseLabel.textContent = `${product.title} — ${
        this.dataset.courseText || 'booked on the course page, where a contact phone is entered'
      }`;
      courseLink.className = 'star-quick-order__quote-link';
      courseLink.href = `${this.dataset.rootUrl}products/${encodeURIComponent(product.handle)}`;
      courseLink.textContent = this.dataset.courseLinkText || 'Book this course';
      status.replaceChildren(courseLabel, courseLink);
      status.dataset.state = 'price-request';
      row.dataset.courseBooking = 'true';
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency: this.dataset.currency,
      }).format(Number(cents) / 100);
    }
  }

  if (!customElements.get('star-quick-order')) {
    customElements.define('star-quick-order', StarQuickOrder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-quote-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normaliseQueryValue = (value, maxLength) => {
      if (typeof value !== 'string') return '';
      return value
        .replace(/[\u0000-\u001f\u007f]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, maxLength);
    };

    const prefillQuoteProducts = (root) => {
      const params = new URLSearchParams(window.location.search);
      const product = normaliseQueryValue(params.get('product'), 240);
      const sku = normaliseQueryValue(params.get('sku'), 120);
      const rawQuantity = normaliseQueryValue(params.get('quantity'), 12);
      const numericQuantity = /^\d+$/.test(rawQuantity) ? Number(rawQuantity) : 0;
      const quantity = numericQuantity > 0 ? String(Math.min(numericQuantity, 999999)) : '';

      if (!product && !sku && !quantity) return;

      const sections = root instanceof Element && root.matches('[data-star-quote-form]')
        ? [root]
        : root.querySelectorAll('[data-star-quote-form]');

      sections.forEach((section) => {
        const textarea = section.querySelector('[data-quote-products]');
        if (!(textarea instanceof HTMLTextAreaElement) || textarea.value.trim()) return;

        const lines = [];
        if (product) lines.push(`${section.dataset.prefillProductLabel}: ${product}`);
        if (sku) lines.push(`${section.dataset.prefillSkuLabel}: ${sku}`);
        if (quantity) lines.push(`${section.dataset.prefillQuantityLabel}: ${quantity}`);

        textarea.value = lines.join('\n');
        textarea.dispatchEvent(new Event('input', { bubbles: true }));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => prefillQuoteProducts(document), { once: true });
    } else {
      prefillQuoteProducts(document);
    }

    document.addEventListener('shopify:section:load', (event) => prefillQuoteProducts(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
